module.exports = __webpack_public_path__ + "img/11-green.a3d1bc64.svg";